import React, { useContext, useMemo } from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { UserContext } from '@contexts/user-context';
import { PrimaryButton } from '@pulse-web-ui/button-v2';
import { WidgetContainer } from '@pulse-web-ui/containers';
import { observer } from 'mobx-react-lite';

import { useStores } from '@shared/hooks';
import {
  AUTH,
  PageHeader,
  TextLink,
  WidgetSubHeaderText,
  getSupportMailDataValues,
} from '@shared/index';

interface IncompleteRegistrationProps {
  authRoute?: string;
}

export const IncompleteRegistration = observer(
  ({ authRoute }: IncompleteRegistrationProps) => {
    const { t } = useTranslation();
    const { getUserName } = useContext(UserContext);
    const {
      MainStore: {
        agentUserStore: { agent },
      },
    } = useStores();
    const username = getUserName();
    const navigate = useNavigate();

    const handleGoToAuth = () => {
      navigate(authRoute || AUTH);
    };

    const values = useMemo(
      () =>
        getSupportMailDataValues({
          t,
          username,
          agent,
          appealPlace: window.location.href,
        }),
      [t, username, agent, window.location.href]
    );

    return (
      <WidgetContainer>
        <PageHeader $marginBottom={8}>
          {t('REGISTRATION_OTP:incompleteRegistration.title')}
        </PageHeader>
        <WidgetSubHeaderText>
          <Trans
            components={{
              supportLink: <TextLink href={values.mailtoHref} />,
            }}
          >
            {t('REGISTRATION_OTP:incompleteRegistration.description') +
              t('COMMON:mailto.body')}
          </Trans>
        </WidgetSubHeaderText>
        <PrimaryButton onClick={handleGoToAuth}>
          {t('REGISTRATION_OTP:incompleteRegistration.okay')}
        </PrimaryButton>
      </WidgetContainer>
    );
  }
);
